import React from 'react'
import classNames from 'classnames'


const Radiobutton = ({ currentCheck, isLight, setBooking }) => (
    <div
        className={classNames('Checkbox', {
            'Checkbox_light': isLight,
            'Checkbox_checked': currentCheck
        })}
    >
        <label className='Checkbox__label'>
            <input type='checkbox' className='Checkbox__field'  onChange={(e) => setBooking(!currentCheck)} />
            <span className='Checkbox__control' />
        </label>

    </div>
)

export default Radiobutton


// WEBPACK FOOTER //
// ./src/components/Radiobutton.jsx